module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-13.1f5192c0.mp3";